import { render, staticRenderFns } from "./AddNewLabel.vue?vue&type=template&id=4ff56242&scoped=true&"
import script from "./AddNewLabel.vue?vue&type=script&lang=js&"
export * from "./AddNewLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ff56242",
  null
  
)

export default component.exports